/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export default ({ color }) => ({
  chartBody: {
    width: '100%',
    borderRight: `1px solid ${color.borderColorLight}`,
    display: 'inline-block',
    paddingLeft: 20,
    boxSizing: 'border-box',
    '& svg': {
      overflow: 'visible !important',
      height: 'auto',
    },
    '& .VictoryContainer': {
      bottom: 22,
      display: 'flex',
      '& div:last-child': {
        height: '100%',
        display: 'flex',
      },
    },
    '@media print': {
      height: '40vw',
      width: '100%',
      borderRight: `0px solid ${color.borderColorLight}`,
    },
  },
  loader: {
    textAlign: 'center',
    height: 400,
    marginTop: 100,
    '& .MuiCircularProgress-colorPrimary': {
      color: color.link,
    },
  },
  loadingLegends: {
    height: 90,
    width: '96%',
    marginTop: 16,
    marginLeft: 16,
    marginRight: 16,
  },
});
